export default "__VITE_ASSET__BVaTbAL0__"